import { wrapTextChildrenWithTypography } from '@/helpers/typography-wrapper'
import TopNavigationBarItem from '@/scopes/common/components/Header/TopNavigationBarItem'
import * as NavigationMenu from '@radix-ui/react-navigation-menu'
import { NavigationMenuLinkProps } from '@radix-ui/react-navigation-menu'
import { space, Typography } from '@sunwebgroup/ui-components'
import { Icon } from '@sunwebgroup/ui-components/uds'
import { PropsWithChildren } from 'react'
import { styled } from 'styled-components'

const NavigationMenuLink = styled(NavigationMenu.Link)`
  ${Typography} {
    pointer-events: none;
  }

  ${Icon} {
    margin-right: ${space('primitives_space_4')};
  }

`

function Link({ children, ...rest }: PropsWithChildren<NavigationMenuLinkProps>) {
  return (
    <NavigationMenuLink asChild {...rest}>
      <TopNavigationBarItem as="a">
        {wrapTextChildrenWithTypography(children)}
      </TopNavigationBarItem>
    </NavigationMenuLink>
  )
}

export const HeaderLink = styled(Link)``
